import { Api } from './constants';
import { pipePromise, handleStatuses } from 'utils';

export const fetchToken = pipePromise(
  (apiKey, deviceID) =>
    fetch(Api.FetchToken, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ApiKey: apiKey,
        DeviceId: deviceID,
      }),
    }),
  handleStatuses(),
  (response) => response.text()
);

export const signup = pipePromise(
  ({ email, name, password, userRoles }, options) => {
    const { token } = options;

    return fetch(Api.Signup, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        Email: email,
        Password: password,
        Name: name,
        Roles: userRoles.join(','),
      }),
    });
  },
  handleStatuses(),
  (response) => response.text()
);

export const fetchUserToken = pipePromise(
  (username, password) =>
    fetch(Api.FetchUserToken, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        Email: username,
        Password: password,
      }),
    }),
  handleStatuses(),
  (response) => response.json()
);

export const verifyEmail = pipePromise(
  ({ email, hash }, options) => {
    const { token } = options;

    return fetch(Api.VerifyEmail(email, hash), {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  handleStatuses(),
  (response) => response.text()
);

export const publishProfile = pipePromise(
  (options) => {
    const { token, publisherID } = options;

    return fetch(Api.PublishProfile, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherID,
      },
      body: JSON.stringify([{ Name: 'RequestedPublish', Value: true }]),
    });
  },
  handleStatuses(),
  (response) => response.json()
);

export const sendVerificationEmail = pipePromise(
  (options) => {
    const { token, publisherID } = options;

    return fetch(Api.SendVerificationEmail, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherID,
      },
    });
  },
  handleStatuses(),
  (response) => response.text()
);
